import { hasAnalyticsConsent } from '@/services/privacy/cookieConsent';

type EventPayload = Record<string, string | number | boolean | undefined>;

const UMAMI_HOST = import.meta.env.VITE_UMAMI_HOST;
const UMAMI_WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID;

let initialized = false;

const SCRIPT_ID = 'canabiz-umami-script';

export const initAnalytics = (): void => {
  if (!hasAnalyticsConsent() || !UMAMI_HOST || !UMAMI_WEBSITE_ID || initialized || import.meta.env.DEV) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.defer = true;
  script.dataset.websiteId = UMAMI_WEBSITE_ID;
  script.dataset.doNotTrack = 'true';
  script.dataset.excludeSearch = 'true';
  script.dataset.performance = 'true';
  script.src = `${UMAMI_HOST.replace(/\/$/, '')}/script.js`;
  document.head.appendChild(script);

  initialized = true;
};

export const disableAnalytics = (): void => {
  document.getElementById(SCRIPT_ID)?.remove();
  const w = window as unknown as { umami?: unknown };
  delete w.umami;
  initialized = false;
};

type UmamiFn = (event: string, props?: EventPayload) => void;

export const trackEvent = (event: string, props?: EventPayload): void => {
  if (!hasAnalyticsConsent()) return;
  const w = window as unknown as { umami?: { track?: UmamiFn } };
  w.umami?.track?.(event, props);
};

export const trackPageview = (): void => undefined;
